import React, { Component } from "react";
import config from "lib/fr-config";
import SubscribeInfoSectionView from "presentational/membership/SubscribeInfoSectionView";
import SubscribeButtonSectionView from "presentational/membership/SubscribeButtonSectionView";
import CouponInfoSectionView from "presentational/membership/CouponInfoSectionView";
import FAQInfoSectionView from "presentational/membership/FAQInfoSectionView";
import TXT from "presentational/common/multinational/TXT";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import styles from "./MembershipPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;
const fontCss = config.css.fontThickness;

const TitleTypographyForDesktop = withStyles({
  root: {
    fontSize: desktopCss.sectionTitleFontSizePX,
    fontWeight: fontCss.bold,
    lineHeight: 1,
    textAlign: "right"
  }
})(Typography);
const TitleTypographyForMobile = withStyles({
  root: {
    fontSize: mobileCss.sectionTitleFontSizePX,
    fontWeight: fontCss.bold,
    lineHeight: 1,
    textAlign: "right"
  }
})(Typography);

const cssXL = {
  root: {},
  sectionTitleWrapper: {
    marginBottom: desktopCss.sectionTitleBottomPadding
  },
  membershipArea: {
    paddingBottom: desktopCss.standardPaddingBetweenContent
  },
  couponScrollIndex: {
    padding: 0,
    position: "relative",
    top: -desktopCss.headerBarHeightPX
  },
  couponArea: {
    paddingBottom: desktopCss.standardPaddingBetweenContent
  },
  faqArea: {
    paddingBottom: desktopCss.standardPaddingBetweenContent
  }
};
const cssXS = {
  root: {
    marginTop:
      -mobileCss.paddingBetweenHeaderbarAndFirstContent +
      mobileCss.paddingBetweenHeaderbarAndFirstContentForMembership
  },
  sectionTitleWrapper: {
    marginBottom: mobileCss.sectionTitleBottomPadding
  },
  membershipArea: {
    paddingBottom: mobileCss.standardPaddingBetweenContent
  },
  couponScrollIndex: {
    padding: 0,
    position: "relative",
    top: -30
  },
  couponArea: {
    paddingBottom: mobileCss.standardPaddingBetweenContent
  },
  faqArea: {
    paddingBottom: mobileCss.standardPaddingBetweenContent
  }
};

class MembershipPanelView extends Component {
  static propTypes = {
    membershipInfo: PropTypes.shape({
      userType: PropTypes.string.isRequired,
      canUseFreeTrial: PropTypes.bool,
      paymentType: PropTypes.oneOf(["freeTrial", "paypal", "portone"]),
      status: PropTypes.oneOf(["activated", "deactivated", "paused"]),
      startTime: PropTypes.string,
      endTime: PropTypes.string,
      nextBillingTime: PropTypes.string,
      endTimeOnCancel: PropTypes.string,
      availableDateOfSubscription: PropTypes.string,

      numOfAllCoupon: PropTypes.number.isRequired,
      numOfPromotionCoupon: PropTypes.number.isRequired,
      numOfReferralCoupon: PropTypes.number.isRequired,
      numOfCouponUnused: PropTypes.number.isRequired,
      numOfCouponUsed: PropTypes.number.isRequired,
      invitedUserCount: PropTypes.number.isRequired
    }),
    priceInfo: PropTypes.object.isRequired,
    onRequestFreeTrial: PropTypes.func.isRequired,
    onSubscribeViaPaypal: PropTypes.func.isRequired,
    onSubscribeViaPortone: PropTypes.func.isRequired,
    onSubmitUnsubscription: PropTypes.func.isRequired,
    onRequestRefundInfo: PropTypes.func.isRequired,
    onSubmitRefund: PropTypes.func.isRequired,
    isLatestMembershipInfo: PropTypes.func.isRequired,
    catchPortonePaymentError: PropTypes.func.isRequired
  };

  getTitleText = (text, deviceType) => {
    return deviceType === "desktop" ? (
      <TitleTypographyForDesktop>{text}</TitleTypographyForDesktop>
    ) : (
      <TitleTypographyForMobile>{text}</TitleTypographyForMobile>
    );
  };

  render() {
    const {
      membershipInfo,
      priceInfo,
      onRequestFreeTrial,
      onSubscribeViaPaypal,
      onSubscribeViaPortone,
      onSubmitUnsubscription,
      onRequestRefundInfo,
      onSubmitRefund,
      isLatestMembershipInfo,
      catchPortonePaymentError
    } = this.props;

    const deviceType = getDeviceType();
    const css = deviceType === "desktop" ? cssXL : cssXS;

    return (
      <div className={cx("root", deviceType)} style={css.root}>
        <div style={css.membershipArea}>
          <div className={cx("title")} style={css.sectionTitleWrapper}>
            {this.getTitleText(
              <TXT name="titleSection_membership" />,
              deviceType
            )}
          </div>
          <SubscribeInfoSectionView priceInfo={priceInfo} />
          <SubscribeButtonSectionView
            membershipInfo={membershipInfo}
            priceInfo={priceInfo}
            onRequestFreeTrial={onRequestFreeTrial}
            onSubscribeViaPaypal={onSubscribeViaPaypal}
            onSubscribeViaPortone={onSubscribeViaPortone}
            onSubmitUnsubscription={onSubmitUnsubscription}
            onRequestRefundInfo={onRequestRefundInfo}
            onSubmitRefund={onSubmitRefund}
            isLatestMembershipInfo={isLatestMembershipInfo}
            catchPortonePaymentError={catchPortonePaymentError}
          />
        </div>
        {/* url /membership#coupon로 접근시 자동스크롤의 기준 div */}
        <div id="coupon" style={css.couponScrollIndex} />
        <div style={css.couponArea}>
          <div className={cx("title")} style={css.sectionTitleWrapper}>
            {this.getTitleText(<TXT name="titleSection_coupon" />, deviceType)}
          </div>
          <CouponInfoSectionView membershipInfo={membershipInfo} />
        </div>
        <div style={css.faqArea}>
          <div className={cx("title")} style={css.sectionTitleWrapper}>
            {this.getTitleText(<TXT name="titleSection_faq" />, deviceType)}
          </div>
          <FAQInfoSectionView />
        </div>
      </div>
    );
  }

  /**
   * url /membership#coupon 으로 접근시 쿠폰 화면으로 자동 스크롤되기위해 추가한 코드.
   */
  componentDidMount() {
    const hash = window.location.hash;
    if (hash) {
      /**
       * setTimeout 을 이용하면 화면의 컴포넌트가 다 그려진후 실행되기에
       * 렌더링전 실행되어 작동 안되는 오류를 차단할 수 있다.
       * */
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            /** behavior -> "smooth", "instant" */
            behavior: "instant"
          });
        }
      }, 0); // 0ms 지연
    }
  }
}

export default MembershipPanelView;
